import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsBikeNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M7 26.83a6.831 6.831 0 006.77-6.01h1.68l4.56-9.12 1.33 2.55A6.81 6.81 0 1025 13.17c-.742 0-1.48.124-2.18.37l-2.46-4.71h2.91a.6.6 0 01.51.25.667.667 0 01-.5 1.09H23v1.66h.28a2.33 2.33 0 001.97-1.14 2.288 2.288 0 00-.1-2.53 2.248 2.248 0 00-1.88-.99h-5.63l1.57 3.01h-8.5L9.457 7.83h2.473l-.88-1.66H4.67l.88 1.66h2.038l2.073 3.9-.9 1.68A6.502 6.502 0 007 13.17a6.83 6.83 0 000 13.66zm17.77-6.03h1.85l-3.02-5.77a4.916 4.916 0 011.4-.2 5.185 5.185 0 11-2.89.89zm-6.67-8.97l-3.16 6.31-3.357-6.31zm-7.51 1.66v-.006l3.023 5.686H7.54zM7 14.83c.319 0 .637.03.95.09l-2.07 3.86 1.06 2.04h5.15A5.162 5.162 0 117 14.83z"
        fill=""
      />
    </svg>
  )
);
SvgSportsBikeNormalMedium.defaultProps = {
  color: 'currentColor',
  size: 32,
  title: undefined,
  titleId: undefined
};
SvgSportsBikeNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsBikeNormalMedium;
